export * from './sidebar.directive';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/directives/sidebar/index.ts